import { render, staticRenderFns } from "./CreateTicketUsers.vue?vue&type=template&id=6e6206d1&scoped=true"
import script from "./CreateTicketUsers.vue?vue&type=script&lang=js"
export * from "./CreateTicketUsers.vue?vue&type=script&lang=js"
import style0 from "./CreateTicketUsers.vue?vue&type=style&index=0&id=6e6206d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6206d1",
  null
  
)

export default component.exports